import styled, { DefaultTheme } from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { fontStyle } from '../../../../theme/helpers/fontStyle';
import { FIELD_STATUS, InputStatus } from '../helpers/getFinalFieldState.types';

interface GetColor {
  theme: DefaultTheme;
  $status?: InputStatus;
}

const getColor = ({ theme, $status }: GetColor) => {
  if ($status === FIELD_STATUS.ERROR) {
    return theme.colors.danger;
  }

  if ($status === FIELD_STATUS.WARNING) {
    return theme.colors.alert;
  }

  if ($status === FIELD_STATUS.SUCCESS) {
    return theme.colors.success;
  }

  return theme.colors.paragraphTextColor;
};

export const $FieldMessage = styled.div<GetColor>`
  ${fontStyle('xs')};
  margin-top: ${spacing('xs')};
  padding: 0;
  color: ${getColor};
`;
